import { TEMPI_VS, SMART_POPUP_IDS, EXPIRE_MINUTE, TEMPI_VP, RETURNING, UNIDENTIFIED, NEW_USER } from './constants.es.js';
import debounce from 'lodash.debounce';

const getCookie = (cname) => {
  var _a;
  const name = cname + "=";
  const decodedCookie = decodeURIComponent((_a = window == null ? void 0 : window.document) == null ? void 0 : _a.cookie);
  const ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    const c = ca[i].trim();
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return void 0;
};
const setCookie = (cname, cvalue, exMinute) => {
  if (!exMinute)
    exMinute = 30 * 24 * 60;
  const d = new Date();
  d.setTime(d.getTime() + exMinute * 60 * 1e3);
  const expires = "expires=" + d.toUTCString();
  document.cookie = `${cname}=${cvalue};${expires};path=/`;
};
const upsertTempiCookie = (iamId, sessionPeriodMinutes = EXPIRE_MINUTE) => {
  const tempiVp = getCookie(TEMPI_VP);
  const tempiVs = getCookie(TEMPI_VS);
  const tempiSmartBannerIds = "[]";
  if (iamId) {
    if (tempiVp !== iamId) {
      setCookie(TEMPI_VP, iamId);
      setCookie(TEMPI_VS, RETURNING, sessionPeriodMinutes);
      setCookie(SMART_POPUP_IDS, tempiSmartBannerIds);
    }
    if (tempiVs !== RETURNING) {
      setCookie(TEMPI_VS, RETURNING, sessionPeriodMinutes);
      setCookie(SMART_POPUP_IDS, tempiSmartBannerIds);
    }
    return {
      tempiVp: iamId,
      tempiVs: RETURNING
    };
  }
  if (tempiVp !== UNIDENTIFIED) {
    setCookie(TEMPI_VP, UNIDENTIFIED);
    setCookie(TEMPI_VS, NEW_USER, sessionPeriodMinutes);
    setCookie(SMART_POPUP_IDS, tempiSmartBannerIds);
    return {
      tempiVp: UNIDENTIFIED,
      tempiVs: NEW_USER
    };
  }
  if (tempiVs === NEW_USER)
    return {
      tempiVp: UNIDENTIFIED,
      tempiVs: NEW_USER
    };
  if (tempiVs !== RETURNING) {
    setCookie(TEMPI_VS, RETURNING, sessionPeriodMinutes);
    setCookie(SMART_POPUP_IDS, tempiSmartBannerIds);
  }
  return {
    tempiVp: UNIDENTIFIED,
    tempiVs: RETURNING
  };
};
const getTempiSmartPopupIds = () => {
  const tempiSmartPopupIds = JSON.parse(getCookie(SMART_POPUP_IDS) || "[]");
  return tempiSmartPopupIds;
};
const setTempiSmartPopupIds = (ids) => {
  setCookie(SMART_POPUP_IDS, JSON.stringify(ids));
};
const debounceSetCookieKeepVisitorSession = debounce(
  (sessionPeriodMinutes = EXPIRE_MINUTE) => {
    const tempiVs = getCookie(TEMPI_VS);
    const tempiSmartPopup = getTempiSmartPopupIds();
    if (!tempiVs) {
      (tempiSmartPopup == null ? void 0 : tempiSmartPopup.length) && setCookie(SMART_POPUP_IDS, "[]");
      return;
    }
    setCookie(TEMPI_VS, tempiVs, sessionPeriodMinutes);
  },
  2e3
);
const mobileRE = /(android|bb\d+|meego).+mobile|armv7l|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|samsungbrowser|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i;
const notMobileRE = /CrOS/;
const isMobile = () => {
  let ua;
  if (!ua && typeof navigator !== "undefined")
    ua = navigator.userAgent;
  if (ua && ua.headers && typeof ua.headers["user-agent"] === "string") {
    ua = ua.headers["user-agent"];
  }
  if (typeof ua !== "string")
    return false;
  return mobileRE.test(ua) && !notMobileRE.test(ua);
};

export { debounceSetCookieKeepVisitorSession, getTempiSmartPopupIds, isMobile, setCookie, setTempiSmartPopupIds, upsertTempiCookie };
